import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';

import firebase from 'firebase/app'
import 'firebase/functions'
import 'firebase/storage'
import 'firebase/auth'
import 'firebase/firestore'

import store from "./store";
import i18n from './i18n'

import Hotjar from 'vue-hotjar'
Vue.use(Hotjar, {
  id: '2373251',
  isProduction: process.env.VUE_APP_ENV === 'production'
})

import InstantSearch from 'vue-instantsearch';
Vue.use(InstantSearch);

import VueCalendly from 'vue-calendly';
Vue.use(VueCalendly);

import VueTour from 'vue-tour'
require('vue-tour/dist/vue-tour.css')
Vue.use(VueTour)


import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
import { CaptureConsole } from '@sentry/integrations';

if (window.location.hostname === 'esnwebservices.com') {
  Sentry.init({
    Vue,
    dsn: "https://48e0f348ff564310ae67d95796cd717c@o589889.ingest.sentry.io/6102723",
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ["esnwebservices.com"],
      }),
      new CaptureConsole({
        levels: ['error']
      })
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });  
}
          


var firebaseConfig = {
  apiKey: process.env.VUE_APP_apiKey,
  authDomain: process.env.VUE_APP_authDomain,
  databaseURL: process.env.VUE_APP_databaseURL,
  projectId: process.env.VUE_APP_projectId,
  storageBucket: process.env.VUE_APP_storageBucket,
  messagingSenderId: process.env.VUE_APP_messagingSenderId,
  appId: process.env.VUE_APP_appId,
  measurementId: process.env.VUE_APP_measurementId
};

if (!firebase.apps.length) {
  const firebaseApp = firebase.initializeApp(firebaseConfig)

  if(window.location.hostname === 'localhost') {
    firebaseApp.functions().useFunctionsEmulator('http://localhost:5001');
    Vue.prototype.$functions = firebaseApp.functions();
  } else {
    Vue.prototype.$functions = firebaseApp.functions('europe-west1');
  }

  Vue.prototype.$db = firebaseApp.firestore()
  Vue.prototype.$auth = firebaseApp.auth()
  Vue.prototype.$storage = firebaseApp.storage();

  let unsubscribeFirebaseUserListener;
  let unsubscribeFirebaseCompanyListener;

  firebase.auth().onAuthStateChanged(async authUser => {
    if (authUser) {
      // User is signed in
      store.dispatch('setIsUserLoggedIn', true)

      // Subscribe to its user document
      unsubscribeFirebaseUserListener = Vue.prototype.$db.collection('users').doc(authUser.uid).onSnapshot(userSnap => {
        const user = userSnap.data();
        if (user) {
          store.dispatch('setUserData', user)
          // Subscribe to its company document
          if (!user.isConsultant && user.companyId) {
            unsubscribeFirebaseCompanyListener = Vue.prototype.$db.collection('companies').doc(user.companyId).onSnapshot(companySnap => {
              const company = companySnap.data();
              if (company) {
                store.dispatch('setCompanyData', company)
                // If company is deactivated, sign the user out immediately
                if (company.isActive === false) {
                  firebase.auth().signOut()
                }
              }
            })
          }
        }
      })

      
      // Get custom claims of companyId
      let customClaimCompanyIdinterval;
      async function getCustomClaimOfCompanyIdIfNeeded() { // eslint-disable-line
        if (store.getters.user.data === null) return; // user was not created/loaded yet. Wait until it is.
        // Note : for users without companyId, this will be running continuously... until they get a companyId.

        // Not for consultants
        if (store.getters.user.data.isConsultant) return clearInterval(customClaimCompanyIdinterval)
        
        // Call cloud function to set custom claim companyId : it gives user the right to access storage's folder /companies/{hisCompany}/...
        await Vue.prototype.$functions.httpsCallable('setCustomClaimOfCompanyId')()
        
        // Propagate the custom claim's token to front.
        const idTokenResult = await Vue.prototype.$auth.currentUser.getIdTokenResult(true)
        if (idTokenResult.claims.companyId) {
          clearInterval(customClaimCompanyIdinterval);
        }
      }
      getCustomClaimOfCompanyIdIfNeeded()
      customClaimCompanyIdinterval = setInterval(getCustomClaimOfCompanyIdIfNeeded, 2000);

      
      
      // Get custom claims of dossierIds
      let customClaimDossierIdsinterval;
      async function getCustomClaimOfDossierIdsIfNeeded() { // eslint-disable-line
        if (store.getters.user.data === null) return; // user was not created/loaded yet. Wait until it is.

        // Only for consultants
        if (!store.getters.user.data.isConsultant) return clearInterval(customClaimDossierIdsinterval)
        
        // Call cloud function to set custom claim DossierIds : it gives user the right to access storage's folder /companies/{hisCompany}/...
        await Vue.prototype.$functions.httpsCallable('setCustomClaimOfDossierIds')()
        
        // Propagate the custom claim's token to front.
        const idTokenResult = await Vue.prototype.$auth.currentUser.getIdTokenResult(true)
        if (idTokenResult.claims.dossierIds) {
          clearInterval(customClaimDossierIdsinterval);
        }
      }
      getCustomClaimOfDossierIdsIfNeeded()
      customClaimDossierIdsinterval = setInterval(getCustomClaimOfDossierIdsIfNeeded, 2000);


    } else {
      // User is not signed in
      store.dispatch('setIsUserLoggedIn', false)
      if (unsubscribeFirebaseUserListener) unsubscribeFirebaseUserListener();
      store.dispatch('setUserData', null)
      if (unsubscribeFirebaseCompanyListener) unsubscribeFirebaseCompanyListener();
      store.dispatch('setCompanyData', null)
      store.dispatch('setAlgoliaSecuredKey', null)

      // User got logged out. If user is in a page where unlogged persons are not allowed, redirect him outside.
      let routerOption = router.options.routes.find(option => option.path === router.currentRoute.path)
      if (routerOption && !!routerOption.beforeEnter && ['checkIsLoggedIn', 'checkIsConsultantLoggedIn'].includes(routerOption.beforeEnter.name)) {
        // User is still at a page where it is required to be loggedIn.
        router.push('/')
      }
    }
  });
}

Vue.config.productionTip = false
new Vue({
  router,
  vuetify,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
